//#region imports
import React, { useEffect } from "react";

// bootstrap
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";

// custom components
import EditEmployeeInfo from "./edit-employee-information";


// redux
import { useDispatch } from "react-redux";
import { resetDeleteEmployeeFlags, resetUpdateEmployeeError } from "_redux/slices/timeline/employees";
import { setShowTimelineSidebar } from "_redux/slices/timeline/timeline-control";

// tremor
import { Subtitle, } from "@tremor/react";

//#endregion

const EmployeeModal = ({ closeEmployeeModal }) => {

  //#region redux
  const dispatch = useDispatch();

  //#endregion

  //#region useEffect

  // reset delete employee flags and close timeline sidebar on render
  useEffect(() => {
    dispatch(resetDeleteEmployeeFlags())
    dispatch(setShowTimelineSidebar(false));
    dispatch(resetUpdateEmployeeError())
  }, []);
  //#endregion

  //#region functions



  //#endregion

  return (
    <Row>

      {/* employee info section */}
      <Col xs={12} className="mx-auto">

        {/* edit employee section */}
        <Row>
          <Subtitle>Employee Information</Subtitle>
        </Row>
        <Row>
          <EditEmployeeInfo closeEmployeeModal={closeEmployeeModal} />
        </Row>

      </Col>



    </Row>
  );
};

export default EmployeeModal;
